import { Component } from '@angular/core';
import { Observable, of, combineLatest } from 'rxjs';
import { tap, map, take } from 'rxjs/operators';

import { Customer, ContactPerson } from 'graphql/models/generated';
import { DataTableResourceType } from 'models/data.model';
import { OfferBase } from 'models/offer.model';
import { OfferService } from 'shared/services/offer.service';
import { StoreService } from 'shared/services/store.service';

@Component({
  selector: 'app-contact-person-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class ContactPersonSearchComponent {
  readonly resourceType: DataTableResourceType = 'ContactPerson';

  constructor(
    private offerService: OfferService,
    private storeService: StoreService
  ) { }

  selectedItem!: ContactPerson;

  offer!: OfferBase;

  customerId = '';

  contactPersonId = '';

  ngOnInit(): void {
    this.init();
  }

  private init(): void {
    combineLatest([
      this.storeService.getCurrentCustomer(),
      this.storeService.getCurrentOffer()
    ])
      .pipe(
        take(1)
      )
      .subscribe(([customer, offer]: [Customer, OfferBase]) => {
        this.offer = offer;
        // Input 'item' (customer) is not available when opening the 'contactPerson-form' modal
        // from the 'customerAll' box in the offer header as a second step in the modal,
        // so the only way to get and set the 'customerId' is from the current store offer
        this.customerId = offer.customerId || customer.id || '';
        this.contactPersonId = offer.contactPersonId || '';
      });
  }

  onSubmit(): Observable<ContactPerson> {
    if (this.contactPersonId && this.contactPersonId === this.selectedItem.id) {
      return of(this.selectedItem);
    }

    // return selected, because Quote returns empty string
    return this.offerService.updateOfferWithContactPerson(this.offer, this.selectedItem)
      .pipe(
        map(() => this.selectedItem),
        tap((item: ContactPerson) => this.storeService.setCurrentDataItem(item))
      );
  }

  onItemSelected(item: ContactPerson): void {
    this.selectedItem = item;
  }
}
